module.exports = __webpack_public_path__ + "img/map_1791549390197_37400.645cdd9d.jpg";